'use client';
import ResetPassword from '@components/Auth/ResetPassword';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import Container from '@repo/ui/src/primitives/Container';

const ResetPasswordView = () => {
  const { push } = useCurrentUrl();

  return (
    <Container maxWidth="2xl" className="py-6 sm:pt-14 sm:pb-8">
      <h4 className="tra-text-web-heading-4 w-full mb-6 sm:mb-8">Reset Password</h4>
      <ResetPassword onSuccess={() => push('/account')} />
    </Container>
  );
};

export default ResetPasswordView;
